import { render } from "./AboutMe.vue?vue&type=template&id=7d4d3e16&scoped=true"
import script from "./_AboutMe.js?vue&type=script&lang=js&external"
export * from "./_AboutMe.js?vue&type=script&lang=js&external"

import "./_AboutMe.less?vue&type=style&index=0&id=7d4d3e16&lang=less&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d4d3e16"]])

export default __exports__